<template>
  <el-row :gutter="20" style="margin-left:5px; margin-right:5px;">
    <p style="white-space:nowrap;">
      <span style="font-weight:bold;font-size:18px;">门票详情</span>
    </p>
    <el-carousel :interval="5000" arrow="never">
      <el-carousel-item v-for="item in 1" :key="item">
        <img :src="dest.imgUrl||$app.nodata.img" style="width:100%;height:100%;cursor:pointer" />
        <!-- <img src="../../assets/portal/default.png" v-if="dest.imgUrl==null ||dest.imgUrl==''"  style="width:100%;height:100%">
        <img :src="dest.imgUrl" v-else>-->
      </el-carousel-item>
    </el-carousel>
    <p style="white-space:nowrap;">
      <span style="font-weight:bold;font-size:18px;">{{result.data.merName}}</span>&nbsp;
      <span style="font-weight:bold;font-size:16px;">地址：{{dest.address}}</span>
    </p>
    <div style="width:100%">
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/yudingmengpiao.png"
      />&nbsp;
      <span style="font-weight:bold;font-size:18px;">门票信息</span>
      <br />
      <div
        style="background-color:#E8D9BC;width:100%;margin-top:10px;padding-bottom:5px;padding-top:1px"
      >
        <!-- <div style="width:100%;height:17px;"></div> -->
        <p>
          <span style="font-weight:bold;font-size:18px;padding-left:30px;">价格：</span>&nbsp;
          <span
            style="font-weight:bold;float:right;padding-right:30px;font-size:18px"
          >￥{{result.data.price||'--'}} 起</span>
        </p>
        <p>
          <span style="font-weight:bold;font-size:18px;padding-left:30px;">所属景点：</span>&nbsp;
          <span
            style="font-weight:bold;float:right;padding-right:30px;font-size:18px"
          >{{dest.destName}}</span>
        </p>
        <p style="float:right;margin-top: 10px;">
          <el-button type="primary"  @click="order(result.data)">立即预订</el-button>
        </p>
      </div>
    </div>
    <br />
    <br />
    <div style="width:100%;">
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/dinpiaoxuzhi.png"
      />&nbsp;
      <span style="font-weight:bold;font-size:18px;font-size: 18px">订票须知</span>
      <br />
      <p style="font-weight:bold;padding-left:30px;font-size: 16px">描述：{{result.data.description}}</p>
      <p style="font-weight:bold;padding-left:30px;font-size: 16px">注意事项：{{result.data.fuwu}}</p>
    </div>
    <div style="width:100%">
      <img
        style="width:24px;height:24px;position: relative;top:5px"
        src="../../assets/portal/Maplocation.png"
      />&nbsp;
      <span style="font-weight:bold;font-size:18px;">景区位置</span>
      <br />
      <br />
      <baidu-map
        v-if="dest.lng"
        :center="{lng: dest.lng, lat: dest.lat} "
        :zoom="12"
        :scroll-wheel-zoom="true"
        style="width:100%;height:320px;"
      >
        <bm-marker :position="{lng: dest.lng, lat: dest.lat}" >
          <bm-label
            :content="dest.destName"
            :labelStyle="{color: 'red', fontSize : '16px'}"
            :offset="{width: 0, height: -30}"
          />
        </bm-marker>
      </baidu-map>
    </div>
    <!-- 评论模块 -->
    <!-- <portal-comment-page :productedId="result.data.merId" productedType="ticket"></portal-comment-page> -->
  </el-row>
</template>
<script>
import Vue from "vue";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: "9862E14DE5d6373de36cd8e91503044b"
});
export default {
  name: "portal-sest-detail-ticket",
  data() {
    return {};
  },
  props: {
    result: {
      type: Object
    }
  },
  mounted() {},
  components: {
    BsDetail: () => import("../../components/bs-detail"),
    PortalCommentPage: () => import("../portal/portal-comment-page")
  },
  methods: {
    order:function(data){
     //  window.location.href="http://m.whlyw.net/SpotTicket/SpotTicket/SpotTicketOrder?TicketId="+data.merId+"&Price="+data.price+"&TicketName="+data.merName+"&Destinationid="+data.objectId+"&webtype=zhuzi"
     window.open("http://m.whlyw.net/SpotTicket/SpotTicket/SpotTicketOrder?TicketId="+data.merId+"&Price="+data.price+"&TicketName="+data.merName+"&Destinationid="+data.objectId+"&webtype=zhuzi")
   }
  },
  computed: {
    dest() {
      if (this.result.data.childDest) {
        return this.result.data.childDest;
      }
      return {};
    }
  }
};
</script>

 <style lang="scss" >
.el-carousel__container {
  position: relative;
  height: 340px;
}

</style>

